import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { MapContainer, TileLayer, Marker, Popup, CircleMarker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

const BAND_COLORS = { low: "#16A34A", medium: "#EAB308", high: "#F97316", critical: "#DC2626" };

export default function GeoMap() {
  const [points, setPoints] = useState([]);
  useEffect(() => { api.get("/cases/geo/points").then(r => setPoints(r.data)).catch(()=>{}); }, []);

  const center = useMemo(() => {
    if (!points.length) return [20.5937, 78.9629]; // India centroid default
    const lat = points.reduce((s,p) => s + p.lat, 0) / points.length;
    const lng = points.reduce((s,p) => s + p.lng, 0) / points.length;
    return [lat, lng];
  }, [points]);

  return (
    <div className="p-8 md:p-10 max-w-[1600px] mx-auto">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="overline">Field Intelligence</div>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight mt-2">GIS Map</h1>
          <p className="mt-2 text-sm text-slate-500">Live case footprint. Colour = risk band.</p>
        </div>
        <div className="flex gap-3 text-xs">
          {Object.entries(BAND_COLORS).map(([k,c]) => (
            <div key={k} className="flex items-center gap-2 border border-slate-300 px-3 py-2">
              <span className="w-3 h-3 rounded-full" style={{background:c}}></span>
              <span className="overline">{k}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="border border-slate-200" style={{height: "70vh"}}>
        <MapContainer center={center} zoom={points.length ? 6 : 5} style={{height:"100%", width:"100%"}} scrollWheelZoom>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; OpenStreetMap contributors'
          />
          {points.map(p => (
            <CircleMarker
              key={p.case_id}
              center={[p.lat, p.lng]}
              radius={9}
              pathOptions={{color: BAND_COLORS[p.risk_band] || "#0033A0", fillColor: BAND_COLORS[p.risk_band], fillOpacity: 0.7, weight: 2}}
            >
              <Popup>
                <div className="font-mono text-xs">{p.case_id}</div>
                <div className="font-semibold">{p.subject_name}</div>
                <div className="text-xs uppercase tracking-wider">{p.category?.replace("_"," ")}</div>
                <div className="text-xs mt-1">Risk: <span className="font-bold" style={{color:BAND_COLORS[p.risk_band]}}>{p.risk_band?.toUpperCase()}</span> ({p.risk_score})</div>
                <Link to={`/cases/${p.case_id}`} className="text-[#0033A0] underline text-xs">Open case →</Link>
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>

      <div className="mt-4 text-xs text-slate-500 font-mono">
        {points.length} geo-tagged case{points.length !== 1 && "s"}. Tag coordinates on the case detail page.
      </div>
    </div>
  );
}
